var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "information" },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { "label-position": "right", "label-width": "130px" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "登记方式" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.childData.complaintsSourceName))
                    ])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "投诉人" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.complainantsName))])
                  ])
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "投诉人电话" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.childData.complainantsPhone))
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "投诉住址" } },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.childData.complaintAddress,
                                placement: "top-start",
                                disabled: _vm.tooltipDisabled(
                                  _vm.childData.complaintAddress,
                                  10
                                )
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.trimStr(
                                      _vm.childData.complaintAddress,
                                      10
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "联系人" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.contact))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "联系人电话" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.phone))])
                  ])
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "问题发生地" } },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.childData.eventalSite,
                                placement: "top-start",
                                disabled: _vm.tooltipDisabled(
                                  _vm.childData.eventalSite,
                                  10
                                )
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.trimStr(_vm.childData.eventalSite, 10)
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "紧急情况" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.childData.situationTypeName))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "投诉来源" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.childData.complaintsSourceName))
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "预约时间" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.childData.appointmentTime))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "投诉内容" } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.childData.complaintContent,
                            placement: "top-start",
                            disabled: _vm.tooltipDisabled(
                              _vm.childData.complaintContent,
                              20
                            )
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.trimStr(_vm.childData.complaintContent, 20)
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("h3", { staticStyle: { "margin-bottom": "10px" } }, [
        _vm._v("派单详情")
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "操作时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.opDate))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作人" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.userName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "left",
              "show-overflow-tooltip": "",
              label: "说明"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(scope.row.remark) }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "完成时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.finishTime))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "完成情况" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.statusValue))])]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }